<div *ngIf="data">
  <div id="head_wrap" [ngClass]="{'headWrapGraduation':graduationPage,'headWrapHrReport':!graduationPage}">
    <div id="closeBtn">
      <span  (click)="close();">×</span>
    </div>

    <h1 id="title" class="fontSize24" *ngIf="graduationPage">毕业典礼</h1>
  </div>

  <div id="wrap" [ngClass]="{'wrapGraduation':graduationPage,'wrapHrReport':!graduationPage}">
    <div id="overview">
      <div id="headPortrait"></div>
      <div id="name" class="fontSize18">{{data.userName}}</div>
      <div id="companyName" class="fontSize14">{{data.companyName}}</div>
      <div id="hrReportTag" class="fontSize18" *ngIf="!graduationPage" [ngClass]="{'personalReportGraduated':data.personalReportStatus==1,'personalReportFailed':data.personalReportStatus==2,'personalReportNotCompleted':data.personalReportStatus==3}">
        <span *ngIf="data.personalReportStatus==1">已毕业</span>
        <span *ngIf="data.personalReportStatus==2">未通过</span>
        <span *ngIf="data.personalReportStatus==3">未完成</span>
      </div>
      <div id="stampWrap" *ngIf="graduationPage">
          <div id="stampGraduated" *ngIf="data.personalReportStatus==1" [ngClass]="{'hide':hideStamp}"></div>
          <div id="stampFailed" *ngIf="data.personalReportStatus==2" [ngClass]="{'hide': hideStamp}"></div>
      </div>
      <!--
      <div id="rank" class="fontSize16" *ngIf="graduationPage">
        你的能力考核在公司中排名第<span class="fontSize27">&nbsp;<i>{{graduation.rank}}</i>&nbsp;</span>名<br/>
        <span class="fontSize14" id="rankText2">（该排名会随着完成学习旅程人数有所变化）</span>
      </div>
      -->
      <div id="totalCountWrap" [ngClass]="{'totalCountWrapGraduation':graduationPage,'totalCountWrapHrReport':!graduationPage}">
        <div id="totalCourse" class="fontSize12">
          <span class="fontSize26">{{data.lessonCount}}</span> 门<br/>
          学习总课程数
        </div>
        <div id="totalExercise" class="fontSize12">
          <span class="fontSize26">{{data.questionCount}}</span> 个<br/>
          完成情景模拟
        </div>
      </div>
    </div>

    <div *ngIf="data.learningTourId > 0">
      <div id="capacityDevelopmentTitleHrReport" class="fontSize26" *ngIf="!graduationPage">能力发展报告</div>

      <div id="capacityDevelopmentWrap" [ngClass]="{'capacityDevelopmentWrapGraduation':graduationPage,'capacityDevelopmentHrReport':!graduationPage}">

        <div id="chartHead" [ngClass]="{'darkBackground':graduationPage,'whiteBackground':!graduationPage}">
          <div class="fontSize16 chartHeadItem" *ngFor="let learningPath of data.learningPaths; let i = index;" [ngClass]="{'chartHeadSelected':selectedAbilityIndex===i && !graduationPage, 'chartHeadSelectedWhite':selectedAbilityIndex===i && graduationPage, 'colorWhite':graduationPage}" (click)="selectAbility(i)">{{learningPath.abilityName}}</div>
        </div>
        <div *ngFor="let graduation of data.learningPaths; let i = index;">
          <div id="capacityDevelopment" *ngIf="i==selectedAbilityIndex && !(graduation.preSurveyLevel == 0&&graduation.postSurveyLevel == 0)" [ngClass]="{'darkBackground':graduationPage,'whiteBackground':!graduationPage}">
          <div id="capacityDevelopmentTitle" class="fontSize27" *ngIf="graduationPage">能力发展报告</div>
          <div class="fontSize18" id="barTitle" [ngClass]="{'barTitleGraduation':graduationPage,'barTitleHrReport':!graduationPage,'fontSize18':graduationPage,'fontSize21':!graduationPage}">
            <span *ngIf="graduationPage&&graduation.preSurveyLevel != 0&&graduation.postSurveyLevel != 0">能力等级诊断考核对比图</span>
            <span *ngIf="!graduationPage&&graduation.preSurveyLevel == 0">考核等级图</span>
            <span *ngIf="!graduationPage&&graduation.postSurveyLevel == 0">诊断等级图</span>
            <span *ngIf="!graduationPage&&graduation.preSurveyLevel != 0&&graduation.postSurveyLevel != 0">诊断考核对比图</span>
          </div>
          <div id="after_wrap_1" *ngIf="graduation.preSurveyLevel != 0">
            <div class="float_left fontSize16" [ngClass]="{'colorffffff':graduationPage,'color4a4a4a':!graduationPage}">
              诊断
            </div>
            <div class="bar_bottom" id="after_wrap_1_left" [ngClass]="{'barBottomGraduation':graduationPage,'barBottomPre':!graduationPage}">
              <div class="bar_top barTopPre" [ngClass]="{'level0':graduation.preSurveyLevel == 0,'level1':graduation.preSurveyLevel == 1,'level2':graduation.preSurveyLevel == 2,'level3':graduation.preSurveyLevel == 3,'level4':graduation.preSurveyLevel == 4,'level5':graduation.preSurveyLevel == 5,'level6':graduation.preSurveyLevel == 6,'level7':graduation.preSurveyLevel == 7}"></div>
            </div>
            <div class="float_right fontSize16" [ngClass]="{'colorffffff':graduationPage,'color4a4a4a':!graduationPage}">
              <span class="fontSize16 wrap_text_1">L{{graduation.preSurveyLevel}}</span><span class="fontSize14">&nbsp;/&nbsp;L7</span>
            </div>
          </div>

          <div id="after_wrap_2" *ngIf="graduation.postSurveyLevel != 0">
            <div class="float_left fontSize16" [ngClass]="{'colorffffff':graduationPage,'color4a4a4a':!graduationPage}">
              考核
            </div>
            <div class="bar_bottom" id="after_wrap_2_left" [ngClass]="{'barBottomGraduation':graduationPage,'barBottomPost':!graduationPage}">
              <div class="bar_top barTopPost" id="after_bar_top" [ngClass]="{'level0':graduation.postSurveyLevel == 0,'level1':graduation.postSurveyLevel == 1,'level2':graduation.postSurveyLevel == 2,'level3':graduation.postSurveyLevel == 3,'level4':graduation.postSurveyLevel == 4,'level5':graduation.postSurveyLevel == 5,'level6':graduation.postSurveyLevel == 6,'level7':graduation.postSurveyLevel == 7}"></div>
            </div>
            <div class="float_right fontSize16" [ngClass]="{'colorffffff':graduationPage,'color4a4a4a':!graduationPage}">
              <span class="fontSize16 wrap_text_1">L{{graduation.postSurveyLevel}}</span><span class="fontSize14">&nbsp;/&nbsp;L7</span>
            </div>
          </div>

          <div id="abilityDetail"  [ngClass]="{'width634':graduationPage,'width688':!graduationPage}">
            <div id="abilityDetailTitle" class="fontSize21">能力详细解读</div>
            <div class="item">
              <div class="fontSize16 lineHeight24">
                <span *ngIf="graduation.postSurveyLevel > 0" [innerHtml]="graduation.postSurveyDescription"></span>
                <span *ngIf="graduation.postSurveyLevel <= 0" [innerHtml]="graduation.preSurveyDescription"></span>
              </div>
            </div>
          </div>

          <div id="review"  [ngClass]="{'width634':graduationPage,'width688':!graduationPage}">
            <div id="reviewTitle" class="fontSize21">
              <span *ngIf="graduation.postSurveyLevel != 0">回顾综述</span>
              <span *ngIf="graduation.postSurveyLevel == 0&&characterReport">个性&nbsp;·&nbsp;能力发展建议</span>
            </div>
            <div id="suggestionText" class="fontSize16 lineHeight24" *ngIf="graduation.postSurveyLevel == 0&&characterReport" [innerHtml]="graduation.preSurveyDevelopment">
            </div>
            <div id="reviewText" class="fontSize16 lineHeight24" *ngIf="graduation.postSurveyLevel != 0">
              <p *ngIf="graduation.postSurveyLevel > graduation.preSurveyLevel">
                "哇，追风少年，你已经跑赢自己啦！无论从能力的发展，还是对个性的管理，你都有所收获！<br />想要更好地在工作中应用所学，就继续发挥个性优势，并避免可能的风险吧。"
              </p>
              <p *ngIf="graduation.postSurveyLevel == graduation.preSurveyLevel">
                "什么，拥有辅导力原力的你竟然只是在原地踏步？！<br />其实，你是有天生优势的哦，继续扬长避短，就是你释放原力的不二法宝！"
              </p>
              <p *ngIf="graduation.postSurveyLevel < graduation.preSurveyLevel">
                "天了噜！学习之后成绩下降了？快用月光宝盒看看到底出了什么问题？是已经把一些知识点还给我们了？还是理解出现了偏差？请回顾自己的学习旅程，看看还有哪里可以提升？<br />在今后的工作中，请善用优势个性，并注意可能的风险，会让你的发展嗖嗖嗖，根本停不下来！"
              </p>
            </div>

            <div id="reviewBtn" class="fontSize16" (click)="showDnaReport()">
              <span *ngIf="graduationPage">回顾我的</span><span *ngIf="!graduationPage">查看该学员</span>“领导力DNA报告”
            </div>
          </div>

        </div>
        </div>
        <div id="notStartWrap"  *ngIf="(!data.learningPaths)||(data.learningPaths[selectedAbilityIndex].preSurveyLevel == 0&&data.learningPaths[selectedAbilityIndex].postSurveyLevel == 0)">
          <div id="notStart">
            <div id="notStartPic"></div>
            <div id="notStartText" class="fontSize16">
              很遗憾，<br/>
              由于你没有开始进行测验，<br/>
              我们无法为你生成报告。<br/>
            </div>
          </div>
        </div>
      </div>

      <!--
      <div id="keyActionAnalysisTitleHrReport" class="fontSize26" *ngIf="!graduationPage && data && data.kas && data.kas.goodKas">关键行动分析</div>

      <div id="keyActionAnalysis" [ngClass]="{'keyActionAnalysisGraduation':graduationPage,'keyActionAnalysisHrReport':!graduationPage}" *ngIf="data && data.kas && data.kas.goodKas">
        <div id="keyActionAnalysisTitle" class="fontSize27" *ngIf="graduationPage && data && data.kas && data.kas.goodKas">关键行动分析</div>

        <div *ngFor="let goodKa of data.kas.goodKas;" class="analysisItem">
          <div class="analysisFrame">
            <div class="analysisFrameLeft">
              <div class="analysisFrameLeftPic analysisFrameLeftPicGood"></div>
              <div class="analysisFrameLeftText fontSize16 analysisFrameLeftTextGood">优秀展现</div>
            </div>
            <div class="analysisFrameRight">
              <div class="analysisFrameRightText fontSize18">{{goodKa.name}}</div>
              <div class="analysisFrameRightStar fontSize16">
                <i class="fa fa-star fa-lg activeStar" *ngFor="let i of Arr(goodKa.level).fill(1)"></i>
                <i class="fa fa-star fa-lg negativeStar" *ngFor="let i of Arr(5-goodKa.level).fill(1)"></i>
              </div>
            </div>
          </div>
          <div class="analysisText fontSize16 lineHeight24">
            {{goodKa.description}}
          </div>
        </div>

        <div *ngFor="let badKa of data.kas.badKas;" class="analysisItem">
          <div class="analysisFrame">
            <div class="analysisFrameLeft">
              <div class="analysisFrameLeftPic analysisFrameLeftPicBad"></div>
              <div class="analysisFrameLeftText fontSize16 analysisFrameLeftTextBad">表现欠佳</div>
            </div>
            <div class="analysisFrameRight">
              <div class="analysisFrameRightText fontSize18">{{badKa.name}}</div>
              <div class="analysisFrameRightStar fontSize16">
                <i class="fa fa-star fa-lg activeStar" *ngFor="let i of Arr(badKa.level).fill(1)"></i>
                <i class="fa fa-star fa-lg negativeStar" *ngFor="let i of Arr(5-badKa.level).fill(1)"></i>
              </div>
            </div>
          </div>
          <div class="analysisText fontSize16 lineHeight24">
            {{badKa.description}}
          </div>
        </div>
      </div>
      -->
    </div>
  </div>

  <div *ngIf="data.learningTourId > 0">
    <div *ngIf="characterReport" id="dnaReport">
        <div id="dnaReportTitle" class="fontSize21">
          {{graduation.userName}}的“领导力DNA报告”
        </div>

        <div id="radar"></div>

        <div class="dnaItem">
          <div class="dnaTitle fontSize18">
            <span class="dnaTitle1">尽责</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.responsibility}}</span><span class="fontSize14">分</span>
          </div>
          <div class="dnaContent fontSize16 lineHeight24">
            <i>“愿意遵守规范，为达成目标而努力的程度。”</i><br/><br/>
            <div [innerHtml]="characterReport.responsibility_description"></div>
          </div>
        </div>

        <div class="dnaItem">
          <div class="dnaTitle fontSize18">
            <span class="dnaTitle1">外向</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.extroversion}}</span><span class="fontSize14">分</span>
          </div>
          <div class="dnaContent fontSize16 lineHeight24">
            <i>“对人际互动和社会认同的需求程度。”</i><br/><br/>
            <div [innerHtml]="characterReport.extroversion_description"></div>
          </div>
        </div>

        <div class="dnaItem">
          <div class="dnaTitle fontSize18">
            <span class="dnaTitle1">情绪稳定</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.emotionality}}</span><span class="fontSize14">分</span>
          </div>
          <div class="dnaContent fontSize16 lineHeight24">
            <i>“对情绪的体验和情感调节的水平。”</i><br/><br/>
            <div [innerHtml]="characterReport.emotionality_description"></div>
          </div>
        </div>

        <div class="dnaItem">
          <div class="dnaTitle fontSize18">
            <span class="dnaTitle1">开放</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.open}}</span><span class="fontSize14">分</span>
          </div>
          <div class="dnaContent fontSize16 lineHeight24">
            <i>“愿意接受新事物、新观念和新刺激的程度。”</i><br/><br/>
            <div [innerHtml]="characterReport.open_description"></div>
          </div>
        </div>

        <div class="dnaItem">
          <div class="dnaTitle fontSize18">
            <span class="dnaTitle1">宜人 </span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.delightful}}</span><span class="fontSize14">分</span>
          </div>
          <div class="dnaContent fontSize16 lineHeight24">
            <i>“愿意关心并理解他人感受的倾向。”</i><br/><br/>
            <div [innerHtml]="characterReport.delightful_description"></div>
          </div>
        </div>
      </div>
    <div *ngIf="!characterReport" id="noDnaReport">
      <div id="noDnaReportPic"></div>
      <div id="noDnaReportText" class="fontSize16">未做领导力DNA测验</div>
    </div>
    <div id="closeBtnReport2" (click)="onCloseBtnReportClick()"></div>

    <div id="shade"></div>


    <img src="../../assets/picture/hrreport/success.png" alt="" id="graduatedPic">

    <div id="graduatedText" class="fontSize18 lineHeight32">
        恭喜你，<br/>
        获得能力考核&nbsp;&nbsp;<span class="textLevel fontSize36"><i>L{{graduation.postSurveyLevel}}</i></span>&nbsp;&nbsp;级别，<br/>
        顺利毕业啦！
    </div>


    <img src="../../assets/picture/hrreport/fail.png" alt="" id="failedPic">
    <div id="failedText" class="fontSize18 lineHeight32">
      <div *ngIf="graduation.postSurveyLevel>0">
        好可惜，<br/>
        能力考核只有&nbsp;&nbsp;<span class="textLevel fontSize36"><i>L{{graduation.postSurveyLevel}}</i></span>&nbsp;&nbsp;级别，<br/>
        来查看你的详细报告吧！
      </div>
      <div *ngIf="graduation.postSurveyLevel==0">
        很遗憾，<br/>
        由于你没有开始进行测验，<br/>
        我们无法为你生成报告，<br/>
        你的学习旅程结束。
      </div>

    </div>
  </div>

  <div id="test">

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/graduation/graduation.component.html